import { vsComponentName as roleDetailPermissionsComponentName } from "./component";
import {
  RoleDetailTabsServiceProvider,
  vsProviderName as RoleDetailTabsServiceProviderName,
} from "../service";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";

roleDetailPermissionsComponentConfig.$inject = [
  RoleDetailTabsServiceProviderName,
];
export function roleDetailPermissionsComponentConfig(
  roleDetailTabsServiceProvider: RoleDetailTabsServiceProvider
) {
  roleDetailTabsServiceProvider.addElement({
    displayName: "Permissions",
    id: "permissions",
    uiSrefFragment: "permissions",
    requiredPermission: "userModify",
    stateDefinition: {
      url: "/permissions",
      component: roleDetailPermissionsComponentName,
      resolve: {
        permissions: [
          ServerUtilityName,
          (serverUtility: ServerUtility) =>
            serverUtility.fetchAll({
              url: "/api/permissions",
              query: { OrderBy: "PermissionName" },
            }),
        ],
      },
    },
  });
}
